var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "dash-button",
      class:
        ((_obj = {}),
        (_obj["dash-button--" + _vm.size] = _vm.size),
        (_obj["dash-button--active"] = _vm.activeStatusBetweenTwoSources),
        _obj),
      attrs: { type: "button" },
      on: { click: _vm.toggleActiveStatus },
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.activeStatusBetweenTwoSources,
              expression: "!activeStatusBetweenTwoSources",
            },
          ],
          staticClass: "dash-button__container",
        },
        [
          _c(
            "span",
            { staticClass: "dash-button__icon" },
            [_vm._t("default"), _vm._v(" "), _vm._t("resting")],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeStatusBetweenTwoSources,
              expression: "activeStatusBetweenTwoSources",
            },
          ],
          staticClass: "dash-button__container",
        },
        [
          _c(
            "span",
            { staticClass: "dash-button__icon" },
            [_vm._t("default"), _vm._v(" "), _vm._t("active")],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dash-button__label",
          class: {
            "dash-button__label--time": "time" in _vm.$slots,
          },
        },
        [
          _c("p", [_vm._t("label")], 2),
          _vm._v(" "),
          "time" in _vm.$slots
            ? _c("p", { staticClass: "time" }, [_vm._t("time")], 2)
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }